import { registerPlugin } from '@capacitor/core';

const SberPay = registerPlugin('SberPay');

export default SberPay;